import { Loader2 } from 'lucide-react'
import React from 'react'

const ShotListGeneratingState = ({ sceneName }: { sceneName: string }) => {
    return (
        <div className="flex h-full w-full justify-center items-center flex-col gap-4">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="text-muted-foreground">Generating shot list for "{sceneName}"...</p>
        </div>
    )
}

export default ShotListGeneratingState
